import { createAsyncThunk } from '@reduxjs/toolkit';
import NotificationApi from 'api/notificationApi';
import { createMessage } from 'utils/commonUtils';

export const getNotifications = createAsyncThunk('notifications/get', async () => {
    const response = (await NotificationApi.getNotifications()).data;
    if (response.status !== 'success') {
        return [];
    }
    return response.data;
});

export const markSeen = createAsyncThunk('notifications/seen', async (id: number) => {
    const response = (await NotificationApi.seenNotification(id)).data;
    createMessage(response.status, response.message);
    return response.status !== 'success' ? 0 : id;
});

export const deleteAllSeenNotification = createAsyncThunk('notifications/delete-all-seen', async () => {
    const response = (await NotificationApi.deleteAllReadNotification()).data;
    createMessage(response.status, response.message);
});

export const deleteAllNotification = createAsyncThunk('notifications/delete-all', async () => {
    const response = (await NotificationApi.deleteAllNotification()).data;
    createMessage(response.status, response.message);
});
